export const ID = '6e3db9c7-5bf1-428c-a0f0-b03a06bf5660';

export const NAME = 'Review Stars';
